import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
export var Perk = function(param) {
    var value = param.value, index = param.index;
    var isMobile = useViewport().isMobile;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            isMobile && index !== 0 ? /*#__PURE__*/ _jsx(Spacer, {
                height: "5x"
            }) : null,
            /*#__PURE__*/ _jsxs(ValueContainer, {
                "data-test-id": "perk-title-".concat(index),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "displaySSerifRegular",
                        align: "center",
                        children: value.head
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        align: "center",
                        children: value.body
                    })
                ]
            })
        ]
    }, index);
};
var ValueContainer = styled(Column).withConfig({
    componentId: "sc-d447eacf-0"
})([
    "padding:",
    ";",
    "{max-width:348px;width:33%;}"
], getSpacing(0, "3x"), responsiveMediaQueries.tabletAndAbove);
